"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXCLUDE_PROPERTIES_FOR_LOWERCASE = exports.CallType = void 0;
// call_type
var CallType;
(function (CallType) {
    CallType["VIEW"] = "view";
    CallType["LINK"] = "link";
    CallType["VIDEO"] = "video";
})(CallType = exports.CallType || (exports.CallType = {}));
exports.EXCLUDE_PROPERTIES_FOR_LOWERCASE = [
    "media_id",
    "media_thumbnail",
    "player_embedurl",
    "player_source",
    "page_url",
];
